import request from '@/modules/base/util/request'
import userConfig from '@/modules/user/config'
import UserListColumnModel from '@/modules/user/components/list/models/user-list-column-model'
import { sanitizeListColumns } from '@/redux/util/sanitizeListColumns'

// actions
const ACTION_PREFIX = 'user/list'
const FINISHED_FETCHING_LIST_SETTING = `${ACTION_PREFIX}/finishedFetchingListSetting`
const ERROR_FETCHING_LIST_SETTING = `${ACTION_PREFIX}/errorFetchingListSetting`
const SHOW_LOADER = `${ACTION_PREFIX}/showLoader`
const HIDE_LOADER = `${ACTION_PREFIX}/hideLoader`
const SET_LIST_ITEMS = `${ACTION_PREFIX}/setListItems`
const SET_PAGINATION = `${ACTION_PREFIX}/setPagination`
const SET_SEARCH_TERM = `${ACTION_PREFIX}/setSearchTerm`
const REFRESH = `${ACTION_PREFIX}/refresh`
const STOP_REFRESHING = `${ACTION_PREFIX}/stopRefreshing`
const FINISHED_FETCHING_USER_LIMIT = `${ACTION_PREFIX}/finishedFetchingUserLimit`

// reducer
const initialState = {
  isLoading: true,
  error: null,
  items: [],
  setting: {
    columns: [],
  },
  searchTerm: '',
  pagination: {
    offset: 0, // current starting point in list
    count: 0, // count of filtered users
    totalCount: 0, // count of all users
    limit: 20, // max users on page
  },
  shouldRefresh: false,
  limitations: {},
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FINISHED_FETCHING_LIST_SETTING:
      const { setting } = action
      return Object.assign({}, state, {
        error: null,
        setting,
      })

    case SHOW_LOADER:
      return Object.assign({}, state, {
        isLoading: true,
      })

    case HIDE_LOADER:
      return Object.assign({}, state, {
        isLoading: false,
      })

    case SET_LIST_ITEMS:
      const { users } = action
      return Object.assign({}, state, {
        items: users,
      })

    case SET_PAGINATION:
      const { pagination } = action
      const updatedPagination = Object.assign({}, state.pagination, pagination)
      return Object.assign({}, state, { pagination: updatedPagination })

    case SET_SEARCH_TERM:
      const { searchTerm } = action
      return Object.assign({}, state, {
        searchTerm,
      })

    case REFRESH:
      return Object.assign({}, state, {
        shouldRefresh: true,
      })

    case STOP_REFRESHING:
      return Object.assign({}, state, {
        shouldRefresh: false,
      })

    case ERROR_FETCHING_LIST_SETTING:
      const { error } = action
      return Object.assign({}, state, {
        isLoading: false,
        error,
      })

    case FINISHED_FETCHING_USER_LIMIT:
      const { limitations } = action
      return Object.assign({}, state, {
        limitations,
      })

    default:
      return state
  }
};

// action creators
export const showLoader = () => {
  return {
    type: SHOW_LOADER,
  }
}

export const hideLoader = () => {
  return {
    type: HIDE_LOADER,
  }
}

export const setUserListItems = (users) => {
  return {
    type: SET_LIST_ITEMS,
    users,
  }
}

export const refreshList = () => {
  return {
    type: REFRESH,
  }
}

export const stopRefreshingList = () => {
  return {
    type: STOP_REFRESHING,
  }
}

export const setPagination = (pagination) => {
  return {
    type: SET_PAGINATION,
    pagination,
  }
}

export const setSearchTerm = (searchTerm) => {
  return {
    type: SET_SEARCH_TERM,
    searchTerm,
  }
}

const finishedFetchingUserListSetting = (setting) => {
  return {
    type: FINISHED_FETCHING_LIST_SETTING,
    setting,
  }
}

const errorFetchingUserListSetting = (error) => {
  return {
    type: ERROR_FETCHING_LIST_SETTING,
    error,
  }
}

export const fetchUserListSetting = () => {
  return (dispatch) => {
    request(userConfig.userListSettingUrl, { auth: true, isConcurrent: true })
      .then((response) => {
        const {
          body: {
            data: { columns },
            meta: {
              defaultSort,
              sortBy,
            },
          },
        } = response

        const sanitizedColumns = sanitizeListColumns(columns, defaultSort, sortBy)
        const userColumns = sanitizedColumns.map((column) => {
          column.displayed = true
          return new UserListColumnModel(column)
        })

        dispatch(finishedFetchingUserListSetting({ columns: userColumns }))
      })
      .catch((error) => {
        dispatch(errorFetchingUserListSetting(error))
      })
  }
}
